import client from './client';
import {
  LoginCredentials,
  RegisterCredentials,
  User,
  LoginResponse,
} from '../types/auth';

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    // ログインAPIでは自動リフレッシュやリダイレクトを無効にする
    const response = await client.post<LoginResponse>('/api/auth/login', credentials, {
      _skipRetry: true, // カスタムフラグで自動リトライを防ぐ
    });
    return response.data;
  },

  register: async (credentials: RegisterCredentials): Promise<LoginResponse> => {
    const response = await client.post('/auth/register', credentials);
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      await client.post('/auth/logout');
    } catch (error) {
      // APIエラーが発生してもログアウト処理は続行
      console.warn('ログアウトAPIでエラーが発生しましたが、クライアント側のクリーンアップを続行します', error);
    }
  },

  refreshToken: async (refreshToken: string): Promise<{ token: string }> => {
    const response = await client.post<{ token: string }>('/auth/refresh', {
      refreshToken,
    });
    return response.data;
  },

  checkAuth: async (): Promise<User | null> => {
    try {
      const response = await client.get('/auth/verify');
      return response.data.user;
    } catch (error) {
      return null;
    }
  },
};

export const { login, logout, register, checkAuth } = authApi; 